<template>
<div class="component">
    <div>
        <div class="button is-large is-info" @click="openNewNBHModal=true">Neu</div>
    </div>

    <div v-for="nbh in nbhs" class="nbhItem columns is-mobile is-multiline">

        <div class="column is-6 nbhTitle" @click="selectNbh(nbh.id)">{{nbh.title}}</div>
        <div class="column is-6 nbhReward" @click="selectNbh(nbh.id)">{{nbh.reward}} <i class="fas fa-leaf"></i></div>

        <transition name="nbhListTransition">
            <div class="columns is-mobile is-multiline" v-if="selectedNbh == nbh.id">
                <div class="nbhDesc column is-12">{{nbh.description}}</div>

                <div class="column is-12 " v-if="nbh.author.id == $store.getters.getUser.id">
                    <div @click="nbhToResolve=nbh" class="button is-success">Erledigen</div>
                </div>

                <div class="  column is-12" v-else> <a class="button">{{nbh.author.firstname}} {{nbh.author.name}}
                       <br /> <router-link class="" :to="{name:'messageCreateWithTitle',params:{messagetitle:'Nachbarschaftshilfe: '+nbh.title,messagereciever:nbh.author.id}}">(Kontakt)
                        </router-link>
                    </a>
                </div>
            </div>
            <!--Pfeil nach unten -->
            <div v-if="selectedNbh != nbh.id" @click="selectNbh(nbh.id)" class="column is-12 openNbhArrow"><i class="fas fa-chevron-down"></i></div>
        </transition>

    </div>

    <div v-if="nbhToResolve!=null" class="modal" :class="{'is-active':nbhToResolve!=null}">
        <div class="modal-background" @click="nbhToResolve=null"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Wähle den entsprechenden Benutzer</p>
                <button class="delete" aria-label="close" @click="nbhToResolve=null"></button>
            </header>
            <section class="modal-card-body">
                <h1 class="title">{{nbhToResolve.title}}</h1>
                <userlist @selected="selectUserForResolve($event, nbhToResolve.id)" />
            </section>
            <footer class="modal-card-foot">
                <button class="button is-error" @click="nbhToResolve=null">Cancel</button>
            </footer>
        </div>
    </div>

    <div v-if="openNewNBHModal!=false" class="modal" :class="{'is-active':openNewNBHModal!=false}">
        <div class="modal-background" @click="closeNewNBHModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Neue Nachbarschaftshilfe</p>
                <button class="delete" aria-label="close" @click="closeNewNBHModal()"></button>
            </header>
            <section class="modal-card-body">
                <div class="columns is-mobile is-multiline">
                    <div class="column is-4"><label class="label">Titel</label></div>
                    <div class="column is-8"><input :class="{'formError':  formErrors.includes('title')}" type="text" class="input" v-model="createNBHObject.title"></div>
                    <div class="column is-4"><label class="label">Beschreibung</label></div>
                    <div class="column is-8"><textarea :class="{'formError':  formErrors.includes('description')}" class="textarea" rows="5" v-model="createNBHObject.description"></textarea></div>

                    <div class="column is-4"><label class="label">Belohnung (Punkte) </label></div>
                    <div class="column is-8"><input type="number" class="input" v-model="createNBHObject.reward"></div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="createNBH">Save changes</button>
                <button class="button" @click="closeNewNBHModal()">Cancel</button>
            </footer>
        </div>
    </div>

</div>
</template>

<script>
import userlist from '@/components/userList.vue';

export default {
    name: 'nachbarschaftshilfe',
    props: [],
    components: {
        userlist
    },
    mounted: function () {
        this.getNBHS();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            nbhs: [],
            nbhToResolve: null,
            openNewNBHModal: false,
            selectedNbh: -1,
            createNBHObject: {
                "title": '',
                'description': '',
                'reward': 10
            },
            formErrors: [],
        }
    },
    methods: {
        getNBHS() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            this.$axios.get(this.$backendURL + "/nbh/get", {
                headers: headerData
            }).then(function (result) {
                this.nbhs = result.data.nbhs
            }.bind(this))
        },
        createNBH() {
            this.validateForm();
            if (this.formErrors.length > 0) {
                return;
            }
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            let postData = {
                'nbh': this.createNBHObject
            }
            this.$axios.post(this.$backendURL + "/nbh/create", postData, {
                headers: headerData
            }).then(function (result) {
                this.createNBHObject = {
                    "title": '',
                    'description': '',
                    'reward': 10,
                    'type': 'nbh'
                }
                this.openNewNBHModal = false;
                this.getNBHS();
            }.bind(this))
        },
        closeNewNBHModal() {
            this.createNBHObject = {
                "title": '',
                'description': '',
                'reward': 10
            }
            this.openNewNBHModal = false;
        },
        validateForm() {
            this.formErrors = []
            if (this.createNBHObject.title == '') {
                this.formErrors.push('title');
            }
            if (this.createNBHObject.description == '') {
                this.formErrors.push('description');
            }
        },
        deleteNBH(nbh) {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            let postData = {}
            this.$axios.post(this.$backendURL + "/nbh/" + nbh.id + "/delete", postData, {
                headers: headerData
            }).then(function (result) {

                this.getNBHS();
            }.bind(this))
        },
        selectUserForResolve(userId, nbhId) {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }
            let postData = {
                'helpedBy': userId
            }
            this.$axios.post(this.$backendURL + "/nbh/" + nbhId + "/resolve", postData, {
                headers: headerData
            }).then(function (result) {
                this.nbhToResolve = null;
                this.getNBHS();
            }.bind(this))
        },
        selectNbh(id) {
            if (this.selectedNbh == id) {
                this.selectedNbh = -1;
            } else {
                this.selectedNbh = id;
            }
        }
    },
    computed: {},
}
</script>

<style scoped>
.nbhObject {
    margin: 10px 0;
}

.nbhTitle {
    line-height: 3;
    white-space: nowrap;
    overflow: hidden;
}

.formError {
    border: 1px solid red;
}

.nbhButton {
    cursor: pointer;
}

.nbhInfo {
    font-size: 1.3em
}

.nbhList {
    margin-top: 25px;
}

.nbhTitle {
    font-size: 2em;
    font-weight: bolder;
    text-align: left;
    line-height: 2em;
}

.nbhReward {
    font-size: 2em;
    font-weight: bolder;
    text-align: right;
    line-height: 2em;
}

.nbhItem {
    border: 1px solid #FFC400;
    border-radius: 20px;
    margin: 1% 0;
    padding: 1em 2em;
    ;
    ;
}

.openNbhArrow {
    font-size: 3em;
}

.nbhListTransition-enter-active {
    transition: all .5s;
    overflow: hidden;

}

.nbhListTransition-leave-active {
    transition: all .5s;
    overflow: hidden;

}

.nbhListTransition-enter,
.nbhListTransition-leave-to {
    opacity: 0;
}

.nbhListTransition-enter-to,
.nbhListTransition-leave {
    opacity: 1;
}
</style>
